export default function split(str: string): string[] {
  const result = [];
  let currentWord = "";
  let isInQuote = false;

  for (let i = 0; i < str.length; i++) {
    const ch = str[i];

    if (ch === " " && !isInQuote) {
      const lower = currentWord.toLowerCase();
      if (lower === "a" || lower === "the") {
        currentWord = currentWord.concat(" ");
      } else if (currentWord.length > 0) {
        result.push(currentWord);
        currentWord = "";
      }
    } else if (ch === '"') {
      currentWord = currentWord.concat(ch);
      isInQuote = !isInQuote;
    } else {
      currentWord = currentWord.concat(ch);
    }
  }

  if (currentWord.length > 0) {
    result.push(currentWord);
    currentWord = "";
  }

  return result;
}
